const Vue = window.Vue;

Vue.component('CategoryItemFeedback', () => import('./CategoryItemFeedback.vue'))